import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "text-center p-4 w-full" }
const _hoisted_2 = { class: "text-center w-full" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = ["placeholder", "max"]
const _hoisted_5 = { class: "text-center p-4 w-full" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Payment ")
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_11 = { class: "block truncate" }
const _hoisted_12 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_13 = { class: "text-center p-4 w-full" }
const _hoisted_14 = { class: "row text-center" }
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = {
  class: "text-red",
  style: {"color":"red"}
}

import { useStore } from "vuex";
import { watch } from "vue";
import { computed, inject, onMounted, ref } from "vue";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import {AxiosInstance} from "axios";
import {Listbox, ListboxButton, ListboxOption, ListboxOptions} from "@headlessui/vue";
import {number} from "maz-ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositWithdrawDialog',
  props: {
  isWithdraw: { type: Boolean, defaultValue: false },
  value: Object as () => Number | String,
  errorText: String,
  date: String,
  open: Boolean,
  payment: {value: Number, label: String},
  note: String
},
  emits: [
  "submit",
  "update:value",
  "update:open",
  "update:date",
  "update:errorText",
  "update:payment",
  "update:note",
],
  setup(__props, { emit }) {

const props = __props

dayjs.extend(localizedFormat);

const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const store = useStore();
const axios = inject("$axios") as AxiosInstance;
// const router = useRouter();

// const axios: any = inject("$axios");

// const totp = ref('')
// const isCheckTOTP = ref(false);


const ErrorSync = computed({
  get: () => props.errorText,
  set: (value) => emit("update:errorText", value),
});
const valueSync = computed({
  get: () => props.value,
  set: (value) => emit("update:value", value),
});
const noteSync = computed({
  get: () => props.note,
  set: (value) => emit("update:note", value),
});
const dateSync = computed({
  get: () => props.date,
  set: (value) => emit("update:date", value),
});
const paymentSync = computed({
  get: () => props.payment,
  set: (value) => emit("update:payment", value),
});
const openSync = computed({
  get: () => props.open,
  set: (value) => {
    emit("update:open", value)
    // totp.value = ''
    // isCheckTOTP.value = false
  },
});

const selectPaymentShow = ref(false);

const selectPaymentList = ref([]);


watch(openSync, async (newVal) => {
  if(newVal && store.state.selectedOperator.multipleDeposit && props.isWithdraw == false){
    selectPaymentShow.value = true;
    const useDepositPayment =  await axios.post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/be-payment/deposit/use-deposit",
        {
          operatorId: store.state.selectedOperator.operatorId,
        }
    )
    const mapUseDeposit = useDepositPayment.data.map((deposit) => ({id: deposit.id, value: deposit.id, label: deposit.name }))
    selectPaymentList.value = mapUseDeposit
  }
})

const onCheckFuture = (e: any) => {
  const now = dayjs(Date.now());
  const diff = now.diff(e, "second");
  if (diff > 0) return;
  else dateSync.value = dayjs(now).format("YYYY-MM-DDTHH:mm");
};

const checkValueDecimalAndMinus = (event) => {
  if(event.key === '.' || event.key ==='-') event.preventDefault()
};

const checkValueMinus = (event) => {
  if(event.key ==='-') event.preventDefault()
};

// const onCheckTOTP = async () => {
//   try {
//     await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/auth/admin-totp-check`,
//       {
//         requestId: Date.now().toString(),
//         requestTs: Date.now(),
//         code: totp.value,
//         userId: store.state.user.id,
//         callerFunction: 'Confirm Approve Deposit'
//       },
//       { headers: { "x-cm-forwarded-for": store.state.user.ip }}
//     )
//     totp.value = ''
//     isCheckTOTP.value = false
//     emit('submit')
//   } catch (e: any) {
//     console.log(e?.response?.data?.isBlackList)
//     if (e?.response?.data?.isBlackList) {
//       store.commit("removeUserInfo");
//       store.commit("removeOperators");
//       router.push({ name: "Login" });
//     }
//     alert('invalid TOTP');
//   }
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogComponent, {
    isOpen: _unref(openSync),
    title: `Manual Payment ${__props.isWithdraw ? 'Withdraw' : 'Deposit'}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.isWithdraw)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "number",
              class: "rounded",
              placeholder: "จำนวนบาท",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSync) ? (valueSync).value = $event : null)),
              onKeydown: checkValueMinus
            }, null, 544)), [
              [_vModelText, _unref(valueSync)]
            ])
          : _createCommentVNode("", true),
        (!__props.isWithdraw)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "number",
              class: "rounded",
              placeholder: "จำนวนบาท",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(valueSync) ? (valueSync).value = $event : null)),
              onKeydown: checkValueDecimalAndMinus
            }, null, 544)), [
              [_vModelText, _unref(valueSync)]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.isWithdraw ? _ctx.$t(`messages.player.id.withdrawDate`) : _ctx.$t(`messages.player.id.depositDate`)) + " ", 1),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            id: "dateSync",
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => (_isRef(dateSync) ? (dateSync).value = $event : null)),
              onCheckFuture
            ],
            placeholder: __props.isWithdraw ? 'Withdraw Date' : 'Deposit Date' ,
            type: "datetime-local",
            max: _unref(dayjs)().format().slice(0, -6),
            class: "rounded",
            name: "dateSync"
          }, null, 8, _hoisted_4), [
            [_vModelText, _unref(dateSync)]
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Listbox), {
              modelValue: _unref(paymentSync),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(paymentSync) ? (paymentSync).value = $event : null))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(paymentSync).label), 1),
                        _createVNode(_unref(SelectorIcon), {
                          class: "w-5 h-5 text-gray-400 ml-auto",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectPaymentList.value, (option, index) => {
                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                              key: index,
                              value: option,
                              as: "template"
                            }, {
                              default: _withCtx(({ active, selected }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass([
                                    active
                                      ? 'text-amber-900 bg-amber-100'
                                      : 'text-gray-900',
                                    'cursor-default select-none relative py-2 pl-10 pr-4',
                                  ])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                                      selected ? 'font-medium' : 'font-normal',
                                      'block truncate',
                                    ])
                                  }, _toDisplayString(option.label), 3),
                                  selected
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                        _createVNode(_unref(CheckIcon), {
                                          class: "w-5 h-5",
                                          "aria-hidden": "true"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ], 512), [
        [_vShow, selectPaymentShow.value]
      ]),
      _createElementVNode("div", _hoisted_13, [
        (!__props.isWithdraw)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "text",
              class: "rounded",
              placeholder: "Note",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(noteSync) ? (noteSync).value = $event : null))
            }, null, 512)), [
              [_vModelText, _unref(noteSync)]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(ErrorSync)), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (openSync.value = false)),
          class: "m-1 p-2 bg-red-500 rounded text-white"
        }, _toDisplayString(_ctx.$t(`messages.player.id.cancel`)), 1),
        _createElementVNode("button", {
          class: "m-1 p-2 bg-blue-500 rounded text-white",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('submit')))
        }, _toDisplayString(__props.isWithdraw ? "Withdraw" : "Deposit"), 1)
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "title"]))
}
}

})